export default (payload) => ({
  type: 'UPDATE_HARDWARES_STATE',
  payload,
});
